module.exports = __webpack_public_path__ + "img/certifications-v2.1bf95ab3.png";